<!--
 * @Description: 省份模板管理
 * @Author: 
 * @Date: 2022-12-28 11:41:16
 * @LastEditTime: 2023-09-08 18:13:46
 * @LastEditors: dongqianqian
 * @Usage: 
-->

<template>
  <div>
    <province />
  </div>
</template>

<script>
import province from '@/views/common/province'
export default {
  data() {
    return {

    };
  },
  components: {
    province
  },
  created() {
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
</style>